import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import classes from "./Inputs.module.css";

function Select(props) {
  const { label, name, children, ...rest } = props;
  return (
    <div className={classes.FormGroup}>
      {label && <label htmlFor={name}>{label}</label>}
      <Field
        as="select"
        id={name}
        name={name}
        className={classes.InputStyle}
        {...rest}
      >
        {children}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default Select;
